import React from 'react'
import { PlaceOrderSameDayPage } from './order.same.day.kits.page';
const UploadBuldPatientDetail = (props) => {
    return (
        <div className='w-100 d-flex justify-content-center'>
            <PlaceOrderSameDayPage {...props} />
        </div>
    )
}
export default UploadBuldPatientDetail